import { useQuery } from "@tanstack/react-query";
import { BlogList } from "@/components/blog/BlogList";
import { FeaturedPosts } from "@/components/blog/FeaturedPosts";
import { RecommendedPosts } from "@/components/blog/RecommendedPosts";
import { BlogSearch } from "@/components/blog/BlogSearch";
import { BlogCategories } from "@/components/blog/BlogCategories";
import { Loader2 } from "lucide-react";
import { getQueryFn } from "@/lib/queryClient";

export default function Blog() {
  const { data: blogData, isLoading } = useQuery({
    queryKey: ['/api/blog'],
    queryFn: getQueryFn({ on401: "throw" })
  });
  
  const { data: featuredData, isLoading: isFeaturedLoading } = useQuery({
    queryKey: ['/api/blog/featured'],
    queryFn: getQueryFn({ on401: "throw" })
  });
  
  if (isLoading || isFeaturedLoading) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }
  
  const posts = blogData?.posts || [];
  const featuredPosts = featuredData?.posts || [];
  
  return (
    <div className="container mx-auto py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold tracking-tight mb-3">
          Karinfinity Blog
        </h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Insights and expertise on data analytics, engineering, and AI trends
        </p>
      </div>
      
      {/* Featured Posts Section */}
      {featuredPosts.length > 0 && (
        <section className="mb-16">
          <h2 className="text-2xl font-bold mb-6">Featured Posts</h2>
          <FeaturedPosts posts={featuredPosts} />
        </section>
      )}
      
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
        {/* Left Sidebar */}
        <div className="lg:col-span-1 space-y-8">
          <BlogSearch />
          <BlogCategories />
        </div>
        
        {/* Main Content */}
        <div className="lg:col-span-2">
          <h2 className="text-2xl font-bold mb-6">Latest Articles</h2>
          <BlogList posts={posts} />
        </div>
        
        {/* Right Sidebar - Recommendations */}
        <div className="lg:col-span-1">
          <RecommendedPosts />
        </div>
      </div>
    </div>
  );
}